// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"23b69c0d","453":"93fb8a51","732":"a60b6d0f","977":"c41ea66c"}[chunkId] + ".chunk.js";
};